/**
 * 10000 => '10,000'
 * @param { number } num
 */
export function toThousandFilter (num) {
  return (+num || 0).toString().replace(/^-?\d+/g, m => m.replace(/(?=(?!\b)(\d{3})+$)/g, ','))
}

/**
 * 900 => '900B'
 * 1524 => '1.49KB'
 * 1159686 => '1.11MB'
 * 1083858888 => '1.85GB'
 * @param { number } flow
 */
export function formatFlow (flow = 0) {
  if (!flow && flow !== 0) {
    return '-'
  } else if (flow < (1 << 10)) { // B
    return `${flow}B`
  } else if (flow < (1 << 20)) { // KB
    return `${(flow / (1 << 10)).toFixed(2)}KB`
  } else if (flow < (1 << 30)) { // MB
    return `${(flow / (1 << 20)).toFixed(2)}MB`
  } else { // GB
    return `${(flow / (1 << 30)).toFixed(2)}GB`
  }
}
